export enum AddressPathEnum {
    Address = '/address/:id',
    AddressFormCreate = '/address/address-form',
    AddressFormUpdate = '/address/address-form/:id',
    AddressCreate = '/address//address-form/create',
    SearchAddress = '/address/search-address',
    AddressListingSelect = '/address/select/:orderType/:addressType',
}
